<template lang="pug">
  div.scale
    div.me(v-for="(n, i) in memo",@click="onclick(i)",@mouseover="onmouseover(i, $event)",@mouseout="onmouseout(i, $event)",:style="style(i)")
      div.plus(v-if="n.display")
      div.pole(:style="sty()")
</template>

<script>
export default {
  name: 'ScaleUnderfloor',
  components: {
  },
  data () {
    return {
      ht: 0,
      set: {},
      memo: [],
      slits: []
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    }
  },
  methods: {
    update () {
      this.set = this.sets[this.number];
      if (this.set !== undefined) {
        this.slits = this.set.slits;
        this.size = this.set.size;
        this.ht = 0;
        if (this.size !== undefined) {
          this.ht = this.c2p(this.size[1] + this.size[3]);
        }
        let last = this.slits[this.slits.length - 1].pos;
        for (let prp in this.memo) {
          let mm = this.memo[prp].pos;
          this.memo[prp].display = false;
          for (let prop in this.slits) {
            if (Number(prop) !== this.slits.length - 1) {
              if (this.slits[prop].pos < mm && this.slits[Number(prop) + 1].pos > mm) {
                if (mm - this.slits[prop].pos >= 45 && mm - this.slits[prop].pos <= 90) {
                  if (this.slits[Number(prop) + 1].pos - mm >= 45 && this.slits[Number(prop) + 1].pos - mm <= 90) {
                    this.memo[prp].display = true;
                  }
                }
              }
            }
          }
          if (mm - last >= 45 && mm - last <= 90) {
            this.memo[prp].display = true;
          }
          if (this.memo[prp].pos > 360) {
            this.memo[prp].display = false;
          }
          if (this.slits[this.slits.length - 1].pos >= 360) {
            this.memo[prp].display = false;
          }
        }
      }
    },
    onclick (num) {
      if (this.memo[num].display) {
        let flg = false;
        let mm = this.p2c(num * 50 + 150);
        const isLargeNumber = (element) => element === mm;
        let chk = this.slits.findIndex(isLargeNumber);
        if (chk === -1 && mm < this.set.size[0]) {
          for (let prop in this.slits) {
            if (prop > 0) {
              if (this.slits[prop - 1].pos < mm && this.slits[prop].pos > mm) {
                if (mm - this.slits[prop - 1].pos >= 45 && mm - this.slits[prop - 1].pos <= 90) {
                  if (this.slits[prop].pos - mm >= 45 && this.slits[prop].pos - mm <= 90) {
                    let obj = {
                      pos: mm,
                      item: [],
                      floor: []
                    };
                    flg = true;
                    this.slits.splice(prop, 0, obj);
                    this.sets.splice(this.number, 1, this.sets[this.number]);
                    this.updateSlit(this.set);
                  }
                }
              }
            }
          }
        }
        if (!flg) {
          let obj = {
            pos: this.memo[num].pos,
            item: [],
            floor: [],
            slit: {}
          };
          this.slits.push(obj);
          this.set.size[0] = this.memo[num].pos;
          this.sets.splice(this.number, 1, this.set);
          this.updateSlit(this.set);
        }
      }
    },
    onmouseover (num, e) {
    },
    onmouseout (num, e) {
      e.currentTarget.classList.remove('none');
    },
    style (i) {
      let ev;
      if (this.memo[i].display) {
        ev = '';
      } else {
        ev = 'none';
      }
      return {
        'pointer-events': ev,
        left: (i * 50) + 150 + 'px'
      };
    },
    sty () {
      return {
        height: this.ht + 'px'
      };
    }
  },
  created () {
    for (let i = 0; i < 60; i++) {
      let obj = {
        pos: 15 * i + 45,
        display: false
      };
      this.memo.push(obj);
    }
    this.update();
  }
};
</script>

<style lang="stylus" scoped>
  .scale
    position absolute
    left 0
    top 10px
    display flex
    .me
      position absolute
      left 0
      top 0
      width 2px
      height 14px
      background-color #000000
      transform translate(-50%,0)
      cursor pointer
      &:after
        content ""
        display block
        position absolute
        top -10px
        bottom -10px
        right -24px
        left -24px
        background-color #ff000000
      &:hover
        opacity 0.7
        div
          display block
      &.off
        display none
      &.none
        display none
      .plus
        /*display none*/
        position absolute
        z-index 2
        left 0
        top -30px
        background-color #000000
        width 19px
        height 5px
        transform translate(-45%, 0)
        .preview &
          display none !important
        &:after
          content ""
          position absolute
          left 7px
          top -7px
          width 5px
          height 19px
          background-color #000000
      .pole
        display none
        position absolute
        top -10px
        left 50%
        border 1px dashed #aaaaaa
        width 8px
        transform translate(-50%, -100%)
</style>



// WEBPACK FOOTER //
// src/components/front/ScaleUnderfloor.vue